export const serverUrl = process.env.REACT_APP_API_URL;
export const wsUrl = process.env.REACT_APP_WS_URL;
